import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"

type Props = {
  fill?: string;
} | SvgProps;

const MoonIcon = ({ fill, ...rest }: Props) => (

  <Svg
    viewBox="0 0 28 28"
    width={28}
    height={28}
    {...rest}
  >
    <Path
      fill={fill ?? "#1C1C1E"}
      d="M18.9 16.4c-4.7 0-7.6-2.7-7.6-7.2 0-1.3.2-2.5.6-3l.1-.8c0-.3-.3-.7-.7-.7l-.6.1A9.3 9.3 0 0 0 5 13.3a9 9 0 0 0 9.2 9.3c3.8 0 7-2 8.4-5.4.2-.2.2-.5.2-.6 0-.5-.3-.7-.7-.7h-.6c-.7.4-1.7.5-2.7.5Zm-12-3.1c0-2.5 1.2-5 3.2-6.3a6 6 0 0 0-.4 2.4c0 5.4 3.3 8.6 8.9 8.6a6 6 0 0 0 2-.3 7.3 7.3 0 0 1-6.2 3.2 7.3 7.3 0 0 1-7.6-7.6Z"
      />
    </Svg>
)

export default MoonIcon
